import { useAuth } from "@/context/AuthContext";

/** Renders children only when the user's access plan includes the module. */
export const ModuleGate = ({ module, label, children }) => {
  const { user, allowedModules = [] } = useAuth();
  const allowed = user?.role === "admin" || allowedModules.length === 0 || allowedModules.includes(module);
  if (allowed) return children;
  return (
    <div className="rounded-md border border-[#E5E7EB] bg-white p-8 text-center" data-testid="module-access-denied">
      <p className="font-heading font-bold text-[#111827]">Not included in your access plan</p>
      <p className="text-sm text-[#6B7280] mt-1">Ask an administrator to grant you access to {label}.</p>
    </div>
  );
};
